module.exports = __webpack_public_path__ + "static/img/sewage.07ea872.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sewage.png
// module id = l+i2
// module chunks = 1